import React from 'react';
import { Observe } from 'rewire-core';
import Button from '@material-ui/core/Button';
import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '../utility/styles';
import BatchDashboardView from './BatchDashboardView';
import BatchDetailsView from './BatchDetailsView';
import createAdjustmentsBatchModel from './CreateAdjustmentsBatchModel';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    flex: '1',
    overflowY: 'auto',
  },
  batchResults: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
  },
  createBatchButton: {
    height: '38px',
    minWidth: '250px',
    flex: '0 0 auto',
    alignSelf: 'center',
    marginBottom: '10px',
  },
  dateContainer: {
    display: 'flex',
    flex: '0 0 auto',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '8px 24px',
    '&> div': {
      margin: '0 16px',
    },
  },
});

const useBatchViewStyles = makeStyles(styles);

export default () => {
  const classes = useBatchViewStyles();
  React.useEffect(() => {
    const handle = setInterval(() => createAdjustmentsBatchModel.loadData(), 3000);
    return () => {
      clearInterval(handle);
    };
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.batchResults}>
        <div className={classes.dateContainer}>
          <div key={createAdjustmentsBatchModel.form.field.start.name}>
            <createAdjustmentsBatchModel.form.field.start.Editor />
          </div>
          <div key={createAdjustmentsBatchModel.form.field.end.name}>
            <createAdjustmentsBatchModel.form.field.end.Editor />
          </div>
        </div>

        <BatchDashboardView model={createAdjustmentsBatchModel} />
        <BatchDetailsView model={createAdjustmentsBatchModel} />

        <Observe>
          {() => {
            const createButton = createAdjustmentsBatchModel.actions['save'];
            return (
              <Button
                className={classes.createBatchButton}
                disabled={createButton.disabled()}
                color="primary"
                variant="contained"
                onClick={createButton.action}
              >
                Create Adjustments Batch
              </Button>
            );
          }}
        </Observe>
      </div>
    </div>
  );
};
